import { CLIENT_ROLES, UserRole } from '@shift/contracts';

/** Roles this app is built for; anything else belongs in the admin app. */
export const CLIENT_APP_ROLES = CLIENT_ROLES;

/** Corporate clients get multi-address management and consolidated invoices. */
export const isCorporate = (roles: readonly UserRole[]): boolean =>
  roles.includes(UserRole.CORPORATE_CLIENT);

/**
 * Whether a set of roles may use this app at all. A worker or tenant account
 * that reaches the client web app is sent to the admin app rather than shown an
 * empty catalog.
 */
export const canUseClientApp = (roles: readonly UserRole[]): boolean =>
  roles.some((role) => CLIENT_APP_ROLES.includes(role));
